'use strict';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
require('../util/static');
Entry.DoneProject = /*#__PURE__*/function () {
  function DoneProject(id) {
    (0, _classCallCheck2["default"])(this, DoneProject);
    this.generateView(id);
  }
  return (0, _createClass2["default"])(DoneProject, [{
    key: "init",
    value: function init(projectId) {
      this.projectId = projectId;
    }
  }, {
    key: "generateView",
    value: function generateView(doneProject) {
      // this.youtubeTab.removeClass('entryRemove');

      var doneContainer = Entry.createElement('div');
      doneContainer.addClass('entryContainerDoneWorkspace');
      // var parentcontainer = document.getElementById('entryContainerWorkspaceId');

      this.doneContainer = doneContainer;
      var view = this.doneContainer;
      // var width = parentcontainer.offsetWidth;

      var url = '/api/iframe/project/';
      var iframe = Entry.createElement('iframe');
      iframe.setAttribute('id', 'doneProjectframe');
      iframe.setAttribute('frameborder', 0);
      iframe.setAttribute('src', url + doneProject);
      this.doneProjectFrame = iframe;
      this.doneContainer.appendChild(iframe);
      doneContainer.addClass('entryRemove');
    }
  }, {
    key: "getView",
    value: function getView() {
      return this.doneContainer;
    }
  }, {
    key: "resize",
    value: function resize() {
      var iframe = document.getElementById('doneProjectframe');
      var w = this.doneContainer.offsetWidth;
      iframe.width = "".concat(w, "px");
      iframe.height = "".concat(w * 9 / 16, "px");
    }
  }]);
}();